import React from 'react';
import PropTypes from 'prop-types';
import styles from './MoldDetails.module.scss';

const MoldDetails = ({ children, className }) => {
  return <div className={`${styles.pickerMoldDetails} ${className ?? ''}`}>{children}</div>;
};

MoldDetails.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  className: PropTypes.string,
};

export default MoldDetails;
